module.exports = __webpack_public_path__ + "img/sidenav.c1dc318b.png";